/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'mobile-menu-button.scss' instead.
import { css } from 'lit';
export default css `@charset "UTF-8";:host button{height:100%;text-decoration:none}:host(.menu-close-button) button{justify-content:end}:host(.menu-open-button){font-size:var(--cipublic-font-size-s);line-height:var(--cipublic-line-height-l)}`;
//# sourceMappingURL=mobile-menu-button.scss.js.map